<template>
  <div class="org-modal">
    <Modal v-model="show" :title="title" :footer-hide="true" :width="900">
      <div class="main">
        <Table
          :columns="tableColumns"
          :data="tableData"
          :max-height="500"
          border
        ></Table>
      </div>
      <div class="page-wrap">
        <Page
          :total="pageInfo.total"
          :page-size="pageInfo.pageSize"
          show-sizer
          show-total
          show-elevator
          :page-size-opts="pageSizeOpts"
          :current="pageInfo.pageNum"
          class="page-right"
          @on-change="handlePageChange"
          @on-page-size-change="onPageSizeChange"
        ></Page>
      </div>
    </Modal>
  </div>
</template>

<script>
import platformApi from '@/request/eduCenter/platform.js'
export default {
  props: {
    eduAreaName: {
      type: String,
      default: ''
    },
    termCode: {
      type: [String, Number],
      default: ''
    },
    yearCode: {
      type: [String, Number],
      default: ''
    },
    bureauOrgId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      orgType: 1, // 1学校，4机构
      show: false,
      tableData: [],
      tableLoading: false,
      pageSizeOpts: [10, 20, 50, 100], //每页条数
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },

      orgColumns: [{
        type: 'index',
        width: 60,
        align: 'center'
      }, {
        title: '机构名称',
        key: 'orgName'
      }, {
        title: '区域',
        key: 'eduAreaName'
      },],
      schColumns: [{
        type: 'index',
        width: 60,
        align: 'center'
      }, {
        title: '学校名称',
        key: 'orgName'
      }, {
        title: '区域',
        key: 'eduAreaName'
      },]
    }
  },
  computed: {
    title() {
      return this.orgType == 1 ? '学期开展课后服务学校' : '学期服务机构'
    },
    tableColumns() {
      return this.orgType == 1 ? this.schColumns : this.orgColumns
    }
  },
  methods: {
    handleInit(orgType) {
      this.pageInfo.pageNum = 1
      this.show = true
      this.orgType = orgType
      this.getList()
    },
    async getList() {
      this.tableLoading = true
      let res = await platformApi.getEduRelOrg({
        yearCode: this.yearCode,
        termCode: this.termCode,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        educationBureauId: this.bureauOrgId,
        orgName: '',
        orgType: this.orgType
      })
      this.tableLoading = false
      if (res.status == 200) {
        res.message.list.forEach(item => {
          item.eduAreaName = this.eduAreaName
        })
        this.pageInfo.total = Number(res.message.total)
        this.tableData = res.message.list
      }
    },
    handlePageChange(page) {
      this.pageInfo.pageNum = page;
      this.getList()
    },
    onPageSizeChange(size) {
      this.pageInfo.pageSize = size;
      this.pageInfo.pageNum = 1;
      this.getList()
    },

  }
}
</script>

<style>
</style>